export interface CsvRow {
  habitName: string
  date: string
}

export interface CsvPreviewGroup {
  habitName: string
  count: number
  firstDate: string
  lastDate: string
}

const VALID_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function parseCsvRows(text: string): CsvRow[] {
  const lines = text.split(/\r?\n/).filter((line) => line.trim())
  if (lines.length < 2) return []

  const header = lines[0]
    .split(',')
    .map((column) => column.trim().toLowerCase())
  const habitIndex = header.indexOf('habit')
  const dateIndex = header.indexOf('date')
  const valueIndex = header.indexOf('value')

  if (habitIndex === -1 || dateIndex === -1 || valueIndex === -1) {
    return []
  }

  return lines.slice(1).reduce<CsvRow[]>((rows, line) => {
    const columns = line.split(',')
    const habitName = columns[habitIndex]?.trim()
    const date = columns[dateIndex]?.trim()
    const value = columns[valueIndex]?.trim()

    if (value === '1' && habitName && date && VALID_DATE_PATTERN.test(date)) {
      rows.push({ habitName, date })
    }

    return rows
  }, [])
}

export function buildCsvPreview(rows: CsvRow[]): CsvPreviewGroup[] {
  const datesByHabit = new Map<string, string[]>()

  for (const row of rows) {
    const dates = datesByHabit.get(row.habitName) ?? []
    dates.push(row.date)
    datesByHabit.set(row.habitName, dates)
  }

  return [...datesByHabit.entries()].map(([habitName, dates]) => {
    const sortedDates = [...dates].sort()

    return {
      habitName,
      count: dates.length,
      firstDate: sortedDates[0],
      lastDate: sortedDates[sortedDates.length - 1],
    }
  })
}
